import {
  TTLElementButton,
  TTLElementContainer,
  TTLElementDescription,
  TTLElementTitle,
} from "../TeachersToolkitLanding.styled";
import React from "react";
import { Box, Button } from "@material-ui/core";

export const TTLElement = ({
  title,
  description,
  icon,
  buttonLabel,
  onClick,
}) => {
  return (
    <TTLElementContainer>
      <Box marginBottom={2}>{icon}</Box>
      <TTLElementTitle>{title}</TTLElementTitle>
      <TTLElementDescription>{description}</TTLElementDescription>
      <TTLElementButton onClick={onClick}>{buttonLabel}</TTLElementButton>
    </TTLElementContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitLanding/components/TTLElement.js